import { useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
// import type { GetBrands } from '@api/interfaces/workspace.brand';
import styled from '@emotion/styled';
import type { UseQueryResult } from '@tanstack/react-query';
// import { GuidedTourPopper, TourStep } from '@/components/GuidedTour/GuidedTourPopper';
// import { useSequentialTour } from '@/components/GuidedTour/useSequentialTour';
import type { GetBrands } from '@trinity/chat/api/interfaces/workspaces';
import { Card, CardContent, GroupCardHeader } from '@trinity/chat-components/components/presentation/Main/index.js';
import * as Table from '@/components/Table';
import * as consts from '@/consts';
import { BrandsTable } from './BrandsTable';
import styles from './style/ActiveProjectsPanel.module.css';

const MaxProjects = 5;

type Props = {
  query: UseQueryResult<GetBrands.Response>;
};

export const ActiveBrandsPanel = ({ query }: Props) => {
  const brandsHeaderRef = useRef<HTMLDivElement>(null);
  // const { isStepActive, goToNextStep, goToPreviousStep, dismissTour, currentStepIndex, totalSteps, isFirstStep } = useSequentialTour();

  const data = useMemo(() => {
    if (query.isLoading) {
      return Array.from({ length: 4 }, _ => ({} as GetBrands.BrandItem));
    } else {
      return query.data.brands.slice(0, 5);
    }
  }, [query.data?.brands, query.isLoading]);

  const showMore = useMemo(() => query.data?.brands?.length > MaxProjects, [query.data?.brands?.length]);
  return (
    <Card>
      <GroupCardHeader className={styles.header}>
        <div ref={brandsHeaderRef}>Brands</div>
      </GroupCardHeader>
      <CardContent fluid>
        <BrandsTable
          items={data}
          isEmpty={data.length === 0}
          isLoading={query.isLoading} />
        {showMore &&
          <Table.Layout.Footer>
            <StyledFooter>
              <Link to={consts.path.Brands.Root}>View More...</Link>
            </StyledFooter>
          </Table.Layout.Footer>}
      </CardContent>
      {/* {isStepActive(TourStep.TRACK_BRANDS) && brandsHeaderRef.current && (
        <GuidedTourPopper
          containerRef={brandsHeaderRef.current}
          step={TourStep.TRACK_BRANDS}
          isOpen={true}
          onNext={goToNextStep}
          onBack={!isFirstStep ? goToPreviousStep : undefined}
          onGotIt={goToNextStep}
          onDismiss={dismissTour}
          placement="right"
          currentStep={currentStepIndex + 1}
          totalSteps={totalSteps}
          showDots={true} />
      )} */}
    </Card>
  );
};

export default ActiveBrandsPanel;

const StyledFooter = styled.div(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.primary.main,
  fontFamily: 'var(--font-semibold)',
  padding: 15,
}));
